export default __webpack_public_path__ + "static/team-3-98d02028157fc8af05b7535e884068f7.jpg";